/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconShotgunShell: {
  name: 'shotgun_shell';
  data: string;
} = {
  name: 'shotgun_shell',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M370.984 445.709v53.789c0 5.379 0 5.379 5.379 5.379h32.273c5.379 0 5.379 0 5.379-5.379v-53.789c0-5.379 0-5.379-5.379-5.379h-32.273c-5.379 0-5.379 0-5.379 5.379zm10.758 5.379h21.516v37.652h-21.516v-37.652zM373.375 512.945h38.25c1.32 0 2.391 1.07 2.391 2.391v8.666c0 1.32-1.07 2.391-2.391 2.391h-38.25a2.391 2.391 0 0 1-2.391-2.391v-8.666a2.391 2.391 0 0 1 2.391-2.391" transform="translate(-2310.666 -2916.414) scale(6.66666)"/></svg>`,
};
